import { Input } from 'antd';
import React, { useState } from 'react';

export interface GraphConfigEditorProps {
	onChange: (value: Record<string, unknown>) => void;
	value: Record<string, unknown>;
}

export const GraphConfigEditor: React.FC<GraphConfigEditorProps> = ({ onChange, value }) => {
	const [ isValid, setIsValid ] = useState(true);

	return <Input.TextArea
		autoSize
		defaultValue={ JSON.stringify(value)
			.replaceAll('{', '{\r\n\t')
			.replaceAll(',"', ',\r\n\t"')
			.replaceAll('}', '\r\n}') }
		onChange={ (e) => {
			try {
				const result = JSON.parse(e.target.value);

				setIsValid(true);
				onChange(result);
			} catch (ex) {
				setIsValid(false);
				console.log(ex);
			}
		} }
		spellCheck={ false }
		status={ isValid ? undefined : 'error' } />;
};
